import { AddCircle, Delete, Edit, RotateLeft } from '@mui/icons-material';
import { Button, Grid } from '@mui/material';
import { toast } from 'components';
import { ConfirmDialog } from 'components/ConfirmDialog';
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { paths } from 'routes';
import { UserActioner } from 'services/user';

function UserSubmitButtonComponent({ fields, setFields, mode, initialValues, reload, ...props }) {
  const intl = props.intl.messages.scenes.submitButtons;
  const userIntl = props.intl.messages.scenes.user.form.button;
  const editIntl = props.intl.messages.scenes.user.edit;
  const toastMessages = props.intl.messages.toast;
  const id = initialValues.id;
  const history = useHistory();

  function setLoading(loading = true) {
    setFields(f => ({ ...f, loading }));
  }

  function setError(name) {
    setFields(f => ({ ...f, errors: { ...f.errors, [name]: true } }));
  }

  function onEdit() {
    const fieldsToSend = {};

    if (fields.firstname !== initialValues.firstname) {
      if (fields.firstname === '') {
        return setError('firstname');
      }
      fieldsToSend.firstname = fields.firstname;
    }

    if (fields.lastname !== initialValues.lastname) {
      if (fields.lastname === '') {
        return setError('lastname');
      }
      fieldsToSend.lastname = fields.lastname;
    }

    if (fields.email !== initialValues.email) {
      if (fields.email === '') {
        return setError('email');
      }
      fieldsToSend.email = fields.email;
    }

    if (Object.entries(fieldsToSend).length === 0) {
      return toast.info(toastMessages.info.noFieldChanged);
    }
    setLoading(true);

    UserActioner.editUser(id, fieldsToSend)
      .then(() => {
        setLoading(false);
        reload();
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function onCreate() {
    if (fields.firstname === '') {
      return setError('firstname');
    }
    if (fields.lastname === '') {
      return setError('lastname');
    }
    if (fields.email === '') {
      return setError('email');
    }
    setLoading(true);
    UserActioner.createNewUser(fields)
      .then(() => {
        setLoading(false);
        history.push(paths.front.user.home);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function onDelete() {
    setLoading(true);
    UserActioner.delete(id)
      .then(() => {
        setLoading(false);
        history.push(paths.front.user.home);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function onReset() {
    if (fields.email && fields.email !== '') {
      UserActioner.forgotPassword(fields.email).then(() => {
        reload();
      });
    }
  }

  return (
    <Grid justifyContent="space-evenly" container>
      <Button
        variant="contained"
        color="primary"
        startIcon={mode === 'edit' ? <Edit /> : <AddCircle />}
        onClick={mode === 'edit' ? onEdit : onCreate}
        disabled={fields.loading}
      >
        {intl.save}
      </Button>
      {mode === 'edit' && (
        <>
          <ConfirmDialog
            onConfirm={onReset}
            button={({ onClick }) => (
              <Button variant="contained" startIcon={<RotateLeft />} onClick={onClick} disabled={fields.loading}>
                {editIntl.resetButton.title}
              </Button>
            )}
          >
            {editIntl.resetButton.modal} {fields.lastname} {fields.firstname}
          </ConfirmDialog>
          <ConfirmDialog
            onConfirm={onDelete}
            button={({ onClick }) => (
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Delete />}
                onClick={onClick}
                disabled={fields.loading}
              >
                {userIntl.title}
              </Button>
            )}
          >
            {userIntl.modal.replace(':nom', fields.lastname).replace(':prenom', fields.firstname)}
          </ConfirmDialog>
        </>
      )}
    </Grid>
  );
}

const UserSubmitButton = injectIntl(UserSubmitButtonComponent);

export { UserSubmitButton };
